import $ from "jquery";
import {GoingUtils,AssertUtils} from "goingutils";
/**
 * 选择父节点
 * @param unitTreeObj
 * @param itemId
 * @param cellObj
 * @private
 */
function _checkParentNode(unitTreeObj, itemId, cellObj) {
    let parentId = unitTreeObj.getParentId(itemId);
    if (AssertUtils.isNotEmpty(parentId)) {
        if (GoingUtils.parseBoolean(unitTreeObj.isItemChecked(parentId))) {
            cellObj.addRecordToAlreadyGrid(parentId);
        } else {
            cellObj.alreadySelGrid.deleteRow(parentId);
        }
    }
}

/**
 * 设置节点的选中状态
 * @param state
 * @param cellObj
 * @param itemId
 * @param unitTreeObj
 * @private
 */
function _setNodeCheck(state, cellObj, itemId, unitTreeObj) {
    state = GoingUtils.parseBoolean(state);
    //判断父节点是否处于选中状态 如果是选中 则添加进来 如果没有选中则删除
    _checkParentNode(unitTreeObj, itemId, cellObj);
    //选中节点
    if (state) {
        cellObj.addRecordToAlreadyGrid(itemId);
        //获取所有子节点 将所有子节点进行选中
        let subItems = unitTreeObj.getAllSubItems(itemId);
        subItems.split(",").forEach(function (subId) {
            if (unitTreeObj.isItemChecked(subId)) {
                cellObj.addRecordToAlreadyGrid(subId);
            } else {
                cellObj.alreadySelGrid.deleteRow(subId);
            }
        });
    } else {
        cellObj.alreadySelGrid.deleteRow(itemId);
        //  获取所有子节点 将所有子节点进行取消
        let subItems = unitTreeObj.getAllSubItems(itemId);
        subItems.split(",").forEach(function (subId) {
            if (unitTreeObj.isItemChecked(subId)) {
                cellObj.addRecordToAlreadyGrid(subId);
            } else {
                cellObj.alreadySelGrid.deleteRow(subId);
            }
        });
    }
}

/**
 * 分隔栏的内容
 * @returns {string}
 * @private
 */
function _getSplitBar() {
    return `<div class="split-bar">
                 <span class="top-btn">
                      <i  class="ivu-icon ivu-icon-ios-arrow-up"></i>
                </span>
                <span class="down-btn">
                    <i  class="ivu-icon ivu-icon-ios-arrow-down"></i>
                </span> 
            </div>`;
}

/**
 * 初始化分隔栏事件
 * @param tabCellObj
 * @private
 */
function _initSplitBarEvent(tabCellObj) {
    if (!AssertUtils.isNotNull(tabCellObj.downMin)) {
        tabCellObj.downMin = "common";
    }
    //向上按钮
    $("#" + tabCellObj.tabId + "_body")
        .find(".top-btn")
        .click(function () {
            //如果是普通模式的话 则向上扩展
            if (tabCellObj.downMin === "common") {
                tabCellObj.downMin = "max";
                tabCellObj.executeLeftCellMax(tabCellObj);
            }
            //如果是最小模式 则向中间扩展
            if (tabCellObj.downMin === "min") {
                tabCellObj.downMin = "common";
                tabCellObj.executeLeftCellToCommon(tabCellObj);
            }
        });
    //向下按钮
    $("#" + tabCellObj.tabId + "_body")
        .find(".down-btn")
        .click(function () {
            //如果是普通模式的话 则向下扩展
            if (tabCellObj.downMin === "common") {
                tabCellObj.downMin = "min";
                tabCellObj.executeLeftCellMin(tabCellObj);
            }
            if (tabCellObj.downMin === "max") {
                tabCellObj.downMin = "common";
                tabCellObj.executeLeftCellToCommon(tabCellObj);
            }
        });
}

function _subItemContents(subItems, width) {
    function getSubItems(subItems) {
        let html = [];
        subItems.forEach(function (item) {
            html.push(
                `<div class="go-drop-item" val="${
                    item.id
                    }" style="text-align: left;" title="${item["label"]}">${
                    item["label"]
                    }</div>`
            );
        });
        return html.join("");
    }

    if (AssertUtils.isArray(subItems) && subItems.length > 0) {
        return ` <div class="common_sel go-common-drop" style="top:69px;left:20px;max-height: 300px; overflow: auto; display: none; width:${parseFloat(
            width
        ) - 40}px;">
            <div class="search-body">
            ${getSubItems(subItems)} 
            </div>
            </div>`;
    } else {
        return ``;
    }
}

function _getFilterSelect(width = 130, label = "请选择数据", subItems, tabId) {
    return ` <ul class="common_search search_sel_filter"  style="width: ${width}px;">
              <li  class="common_search_input">
              <input style="width: ${width - 30}px;" id="${tabId}_search_input"  class="search_input color_gray" type="text"  placeholder="${label}">
               <input   id="${tabId}_search_input_val" type="hidden"  class="search_input color_gray input_val" type="text">
               </li>
              <li><a style="color: #262626;position: relative;top:2px;" class="ivu-icon ivu-icon-md-arrow-dropdown" onclick="searchItems()"></a></li>
          </ul>
          ${_subItemContents(subItems, width)} 
`;
}

function _AccountTreeDrop(width, tabId) {
    return ` <div class="account_sel_tree go-common-drop" style="top:99px;left:10px;max-height: 400px; overflow: auto; display: none; width:${parseFloat(
        width
    ) + 100}px;">
              <div id="${tabId}_account_sel_div" style="width:${parseFloat(
        width
    ) + 98}px;height:390px;overflow:auto;"></div>
            </div>`;
}

function _getAccountChange(width = 130, label = "请选择数据", tabId) {
    return ` <ul class="common_search account_sel"  style="width: ${width}px;">
              <li  class="common_search_input">
              <input style="width: ${width - 30}px;"  class="account-change-input search_input color_gray" type="text" placeholder="${label}"></li>
              <li><a style="color: #262626;position: relative;top:2px;" class="ivu-icon ivu-icon-md-arrow-dropdown" onclick="searchItems()"></a></li>
          </ul>
          ${_AccountTreeDrop(width, tabId)} 
`;
}

function _getAlSelSearchInput(width = 135, label = "请输入名称") {
    return `<ul class="common_search" style="width: ${width}px;">
              <li  class="common_search_input">
              <input style="width: ${parseFloat(width) -
    35}px;" class="search_al_sel_userName_input   common_search_input  search_input color_gray" type="text"    placeholder="${label}"></li>
              <li><a style="position: relative;top:2px;" class="search_al_sel_userName_input_icon ivu-icon ivu-icon-ios-search"></a></li>
          </ul>`;
}

function _getSearchInput(width = 135, label = "请输入名称", tabId) {
    if (!AssertUtils.isNotEmpty(tabId)) {
        tabId = GoingUtils.getUUid(10);
    }
    return `<ul class="common_search"  style="width: ${width}px;">
              <li  class="common_search_input">
              <input style="width: ${parseFloat(width) -
    35}px;" class="search_userName_input   common_search_input  search_input color_gray" type="text"  id="${tabId}_search_input_text"    placeholder="${label}"></li>
              <li><a style="position: relative;top:2px;" class="search_userName_input_icon ivu-icon ivu-icon-ios-search"></a></li>
          </ul>`;
}

function _getGroupCheckBox() {
    return `   <label class="sell-all-account ivu-checkbox-wrapper ivu-checkbox-group-item ivu-checkbox-default">
                <span class="ivu-checkbox"><span class="ivu-checkbox-inner"></span> <input type="checkbox" class="ivu-checkbox-input" value="查全集团"></span>
                <span>查全集团</span>
              </label>`;
}

let _dataFromMap={user:'人员',depart:'部门',unit:'单位',role:'角色',station:'岗位',outUnit:'编外单位',jobLevel:'职务级别',groupUser:'用户群组',departUser:'人员'};
export {
    _getSplitBar,
    _getAccountChange,
    _getSearchInput,
    _getGroupCheckBox,
    _initSplitBarEvent,
    _getFilterSelect,
    _getAlSelSearchInput,
    _checkParentNode,
    _setNodeCheck,
    _dataFromMap,
};



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/comJs.js